var ME_STORAGE_VERSION = 2;
var ME_STORAGE_KEY = 'lendi_me';
export var saveMeToStorage = function (_a) {
    var firstName = _a.firstName, phone = _a.phone, email = _a.email, ownerId = _a.ownerId, storeId = _a.storeId;
    sessionStorage.setItem(ME_STORAGE_KEY, JSON.stringify({
        firstName: firstName,
        phone: phone,
        email: email,
        ownerId: ownerId,
        storeId: storeId,
        version: ME_STORAGE_VERSION,
    }));
};
export var getMeFromStorage = function () {
    try {
        var me = JSON.parse(sessionStorage.getItem(ME_STORAGE_KEY) || '{}');
        if (me.version === ME_STORAGE_VERSION) {
            return me;
        }
        return undefined;
    }
    catch (e) {
        return undefined;
    }
};
//# sourceMappingURL=MeSessionStorage.js.map